import { useDashboardStore } from '../../store/dashboardStore'
import { useT } from '../../hooks/useTranslation'

const PERIOD_IDS = ['daily', 'weekly', 'monthly', 'total']

export default function TimeTabs() {
  const t = useT()
  const period = useDashboardStore(s => s.period)
  const setPeriod = useDashboardStore(s => s.setPeriod)
  const haptic = window.Telegram?.WebApp?.HapticFeedback

  const PERIODS = [
    { id: 'daily',   label: t.periodDaily   },
    { id: 'weekly',  label: t.periodWeekly  },
    { id: 'monthly', label: t.periodMonthly },
    { id: 'total',   label: t.periodTotal   },
  ]

  return (
    <div
      className="flex rounded-xl p-1 mb-4"
      style={{ background: '#1A1A1A' }}
    >
      {PERIODS.map(({ id, label }) => {
        const isActive = period === id
        return (
          <button
            key={id}
            onClick={() => { setPeriod(id); haptic?.impactOccurred('light') }}
            className="flex-1 text-[13px] font-semibold rounded-lg transition-all active:scale-95"
            style={{
              minHeight: 44,
              background: isActive ? 'linear-gradient(135deg, #34D399 0%, #10B981 100%)' : 'transparent',
              color: isActive ? '#FFFFFF' : '#636366',
            }}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
